import { Link } from 'react-router-dom';
import { Chip } from '../app/ui';
import { useApi } from '../lib/useApi';
import type { SessionRow } from '../lib/types';

/** A one-line pointer to agent sessions that are blocked on the owner (the Waiting page's "Happening now" hook). */
export function SessionStrip() {
  const q = useApi<{ sessions: SessionRow[] }>('sessions_now', {}, { poll: 60000 });
  const need = (q.data?.sessions ?? []).filter((s) => s.needsErwin || s.state === 'blocked');
  if (!need.length) return null;
  return (
    <Link to="/now" className="strip">
      <Chip tone="orange">{need.length}</Chip>
      <span>{need.length === 1 ? 'agent session needs you' : 'agent sessions need you'}: {need.slice(0, 2).map((s) => s.title || s.tool).join(', ')}</span>
    </Link>
  );
}
